export default "__VITE_ASSET__pa7kD9Nb__"